import { render, staticRenderFns } from "./Top-Home-Default-Group.vue?vue&type=template&id=63acfe7e&"
import script from "./Top-Home-Default-Group.vue?vue&type=script&lang=js&"
export * from "./Top-Home-Default-Group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports